export default {
    /**
     * 查询缓存key
     * @param {*} key 
     */
    fetch(key) {
        if (window.localStorage.getItem(key) == undefined) {
            return null;
        } else {
            return JSON.parse(window.localStorage.getItem(key))
        }
    },
    /**
     * 保存key，value
     * @param {*} key 
     * @param {*} items 
     */
    save(key, items) {
        window.localStorage.setItem(key, JSON.stringify(items))
    },

    remove (key) {
        window.localStorage.removeItem(key)
    },
    /**
     * 获取整屏高度
     */
    getDocHeight() {
        return `${document.documentElement.clientHeight}`
    },
    /**
     * 判断是手机端还是pc端
     */
    getClient() {
        if (
            navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
        ) {
            /*window.location.href="你的手机版地址";*/
            return true
        }
        return false
    },
    matchMedia() {
        if (window.matchMedia("(orientation: portrait)").matches) {
            // 竖屏
            return true
        } else {
            return false
        }
    },
    // 合并json
    extend(target, source) {
        for (var obj in source) {
            target[obj] = source[obj]
        }
        return target
    },

}


// WEBPACK FOOTER //
// ./src/js/common.js